import { render, staticRenderFns } from "./faqList.vue?vue&type=template&id=67119ecc&"
import script from "./faqList.vue?vue&type=script&lang=js&"
export * from "./faqList.vue?vue&type=script&lang=js&"
import style0 from "./faqList.vue?vue&type=style&index=0&id=67119ecc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports